export const LOCALES = ['en-US', 'es-ES'] as const;

export type Locale = (typeof LOCALES)[number];
